export const CONTENT_TAXONOMY = {

  Editorial: {
    label: "Editorial",
    contentType: "article",
    path: "/editorial",
    children: {},
  },


  Articles: {
    label: "Articles",
    contentType: "article",
    path: "/articles",

    children: {

      International: {
        label: "International",
        contentType: "article",
        path: "/articles/international",
      },

      National: {
        label: "National",
        contentType: "article",
        path: "/articles/national",
      },

      State: {
        label: "State",
        contentType: "article",
        path: "/articles/state",
      },

      Sports: {
        label: "Sports",
        contentType: "article",
        path: "/articles/sports",
      },

      "Science & Technology": {
        label: "Science & Technology",
        contentType: "article",
        legacyValues: [
          "Science",
        ],
        path: "/articles/science",
      },

      "Ink and Echo": {
        label: "Ink and Echo",
        contentType: "article",

        legacyValues: [
          "Cultural",
          "Culture",
        ],

        path: "/articles/ink-and-echo",

        children: {

          Stories: {
            label: "Stories",
            contentType: "article",
            path: "/articles/ink-and-echo/stories",
          },

          Poems: {
            label: "Poems",
            contentType: "article",
            path: "/articles/ink-and-echo/poems",
          },

          Articles: {
            label: "Articles",
            contentType: "article",
            path: "/articles/ink-and-echo/articles",
          },

        },
      },

      Environment: {
        label: "Environment",
        contentType: "article",
        path: "/articles/environment",
      },

      "Her Space": {
        label: "Her Space",
        contentType: "article",
        path: "/articles/her-space",
      },

      "Tribal Voices": {
        label: "Tribal Voices",
        contentType: "article",
        path: "/articles/tribal-voices",
      },

    },
  },


  News: {
    label: "News",
    contentType: "article",
    path: "/news",

    children: {

      State: {
        label: "State",
        contentType: "article",
        path: "/news/state",
      },

      National: {
        label: "National",
        contentType: "article",
        path: "/news/national",
      },

      Organisational: {
        label: "Organisational",
        contentType: "article",
        path: "/news/organisational",

        legacyValues: [
          "Organizational",
        ],
      },

      "Press Release": {
        label: "Press Release",
        contentType: "article",
        path: "/news/press-release",

        legacyValues: [
          "PressRelease",
          "Press-Release",
        ],
      },

    },
  },


  "Campus Report": {
    label: "Campus Report",
    contentType: "article",
    path: "/campus-report",

    legacyValues: [
      "CampusReport",
    ],

    children: {},
  },


  Media: {
    label: "Media",
    contentType: "media",
    path: "/photos-videos",

    legacyValues: [
      "Photos & Videos",
      "PhotosVideos",
    ],

    children: {

      Photos: {
        label: "Photos",
        contentType: "photo",
        path: "/photos-videos/photos",
      },

      Videos: {
        label: "Videos",
        contentType: "video",
        path: "/photos-videos/videos",
      },

      "Chatra Sanglap": {
  label: "Chatra Sanglap",
  contentType: "video",
  path: "/photos-videos/chatra-sanglap",
},

    },
  },

};